var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'bar-on-right-container': _vm.barIsOnRight },attrs:{"title":_vm.formatQuota(3)}},[_c('span',[_vm._v(_vm._s(_vm.formatQuota(0)))]),_c('span',{class:{ 'bar-on-right': _vm.barIsOnRight }},[_c('b-progress',{attrs:{"max":_vm.maxValue,"value":_vm.currentValue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }